import React from 'react'
import { connect } from 'react-redux'
import { Card, Table, Tag, Modal, Button, Select, Input, Row, Col } from 'antd'
import AdminLayout from '../../components/AdminLayout'
import { fetchChangeLogs, fetchChangeLogDetail } from '../../actions/changelog'

const { Option } = Select

class ChangeLogList extends React.Component {
  state = {
    detailModalVisible: false,
    filters: {
      table_name: undefined,
      action: undefined,
    },
  }

  componentDidMount() {
    this.props.fetchChangeLogs()
  }

  handleTableChange = (pagination) => {
    const { filters } = this.state
    this.props.fetchChangeLogs({
      $skip: (pagination.current - 1) * pagination.pageSize,
      $limit: pagination.pageSize,
      ...filters,
    })
  }

  handleFilterChange = (key, value) => {
    const filters = { ...this.state.filters, [key]: value || undefined }
    this.setState({ filters })
    this.props.fetchChangeLogs({ ...filters, $skip: 0, $limit: 20 })
  }

  handleViewDetail = (record) => {
    this.props.fetchChangeLogDetail(record.id)
    this.setState({ detailModalVisible: true })
  }

  renderJsonDiff = (label, data) => {
    if (!data) return null
    return (
      <div style={{ marginBottom: 16 }}>
        <strong>{label}:</strong>
        <pre style={{
          background: '#f5f5f5',
          padding: 12,
          borderRadius: 4,
          overflow: 'auto',
          maxHeight: 300,
          fontSize: 12,
        }}>
          {JSON.stringify(data, null, 2)}
        </pre>
      </div>
    )
  }

  render() {
    const { data, total, skip, limit, isLoading, detail, isDetailLoading } = this.props

    const columns = [
      {
        title: 'Date',
        dataIndex: 'created_at',
        key: 'created_at',
        width: 180,
        render: (val) => new Date(val).toLocaleString(),
      },
      {
        title: 'User',
        dataIndex: 'administrator_name',
        key: 'administrator_name',
        width: 150,
      },
      {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        width: 100,
        render: (action) => {
          const colors = { create: 'green', update: 'blue', delete: 'red' }
          return <Tag color={colors[action]}>{action.toUpperCase()}</Tag>
        },
      },
      {
        title: 'Table',
        dataIndex: 'table_name',
        key: 'table_name',
        width: 150,
      },
      {
        title: 'Record ID',
        dataIndex: 'record_id',
        key: 'record_id',
        width: 100,
      },
      {
        title: 'Details',
        key: 'details',
        render: (_, record) => (
          <Button type='link' onClick={() => this.handleViewDetail(record)}>
            View
          </Button>
        ),
      },
    ]

    const tableOptions = [
      'administrators', 'members', 'news', 'events', 'pages', 'practice_areas',
    ]

    return (
      <AdminLayout title='Change Logs'>
        <Card>
          <Row gutter={16} style={{ marginBottom: 16 }}>
            <Col span={6}>
              <Select
                placeholder='Filter by Table'
                allowClear
                style={{ width: '100%' }}
                onChange={(val) => this.handleFilterChange('table_name', val)}
              >
                {tableOptions.map(t => <Option key={t} value={t}>{t}</Option>)}
              </Select>
            </Col>
            <Col span={6}>
              <Select
                placeholder='Filter by Action'
                allowClear
                style={{ width: '100%' }}
                onChange={(val) => this.handleFilterChange('action', val)}
              >
                <Option value='create'>Create</Option>
                <Option value='update'>Update</Option>
                <Option value='delete'>Delete</Option>
              </Select>
            </Col>
          </Row>

          <Table
            dataSource={data}
            columns={columns}
            rowKey='id'
            loading={isLoading}
            pagination={{
              current: Math.floor(skip / limit) + 1,
              pageSize: limit,
              total,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} records`,
            }}
            onChange={this.handleTableChange}
          />
        </Card>

        {/* Detail Modal */}
        <Modal
          title='Change Log Details'
          visible={this.state.detailModalVisible}
          onCancel={() => this.setState({ detailModalVisible: false })}
          footer={[
            <Button key='close' onClick={() => this.setState({ detailModalVisible: false })}>
              Close
            </Button>,
          ]}
          width={800}
        >
          {isDetailLoading ? (
            <div style={{ textAlign: 'center', padding: 40 }}>Loading...</div>
          ) : detail ? (
            <div>
              <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={8}>
                  <strong>Date:</strong><br />
                  {new Date(detail.created_at).toLocaleString()}
                </Col>
                <Col span={8}>
                  <strong>User:</strong><br />
                  {detail.administrator_name}
                </Col>
                <Col span={8}>
                  <strong>Action:</strong><br />
                  <Tag color={{ create: 'green', update: 'blue', delete: 'red' }[detail.action]}>
                    {detail.action?.toUpperCase()}
                  </Tag>
                </Col>
              </Row>
              <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={12}>
                  <strong>Table:</strong> {detail.table_name}
                </Col>
                <Col span={12}>
                  <strong>Record ID:</strong> {detail.record_id}
                </Col>
              </Row>
              {detail.ip_address && (
                <p><strong>IP Address:</strong> {detail.ip_address}</p>
              )}
              {this.renderJsonDiff('Previous Data', detail.previous_data)}
              {this.renderJsonDiff('New Data', detail.new_data)}
            </div>
          ) : null}
        </Modal>
      </AdminLayout>
    )
  }
}

const mapStateToProps = (state) => ({
  data: state.changelog.data,
  total: state.changelog.total,
  skip: state.changelog.skip,
  limit: state.changelog.limit,
  isLoading: state.changelog.isLoading,
  detail: state.changelog.detail,
  isDetailLoading: state.changelog.isDetailLoading,
})

const mapDispatchToProps = {
  fetchChangeLogs,
  fetchChangeLogDetail,
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangeLogList)

